export interface IWebBridgeCallable {
  call: (command: any, params: Record<string, any>) => Promise<any>
}

export const sdk = {
  webBridge: {
    call: (command: any, params: Record<string, any>) => new Promise<any>(() => {})
  }
}

export const registerWebBridge = (_webBridge: IWebBridgeCallable) => {
  sdk.webBridge = _webBridge
}
